export default {
    SET_CONFIG(state, payload) {
        state.config = payload;
    }
}